var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "add-label-dialog",
          attrs: {
            visible: _vm.dialogVisibleM,
            "modal-append-to-body": false,
            width: "1000px",
            height: "66vh",
            "close-on-click-modal": false
          },
          on: {
            close: _vm.closeDialog,
            "update:visible": function($event) {
              _vm.dialogVisibleM = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _c("h1", { staticClass: "pop-title" }, [
                    _vm._v(_vm._s(_vm.titleName) + " ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "title-row" }, [
                    _vm._v(
                      "知识集内容会上传至企微官方服务器，可以被AI助手引用，用于生成回复内容"
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "pupop-container"
            },
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  staticClass: "demo-ruleForm",
                  staticStyle: { overflow: "auto", "max-height": "55vh" },
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "知识集名称", prop: "kbName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "360px" },
                        attrs: {
                          size: "small",
                          clearable: "",
                          "show-word-limit": "",
                          maxlength: 20,
                          placeholder: "请输入知识集名称"
                        },
                        model: {
                          value: _vm.formData.kbName,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "kbName", $$v)
                          },
                          expression: "formData.kbName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "知识集内容", prop: "docList" } },
                    [
                      _c("span", { staticClass: "content-title" }, [
                        _vm._v("可添加下列内容，总数不超过1000条")
                      ]),
                      _c("div", { staticClass: "content-btn-row" }, [
                        _c(
                          "div",
                          { staticClass: "content-btn" },
                          [
                            _c(
                              "el-upload",
                              {
                                ref: "uploadFileItem",
                                staticClass: "upload-demo",
                                attrs: {
                                  multiple: true,
                                  action: _vm.sendUrl,
                                  headers: _vm.headers,
                                  "show-file-list": false,
                                  disabled: _vm.progressVisible,
                                  accept: _vm.fileTypeArr.join(","),
                                  "on-progress": _vm.handleProgress,
                                  "before-upload": _vm.beforeUploadFile,
                                  "on-success": _vm.handleFileSuccess,
                                  "on-error": _vm.onError
                                }
                              },
                              [
                                _c(
                                  "h3",
                                  {
                                    class: [
                                      { "disabled-h": _vm.progressVisible }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.addBtn(1)
                                      }
                                    }
                                  },
                                  [
                                    _c("el-image", {
                                      staticClass: "start-icon",
                                      attrs: {
                                        src: require("@/assets/img/content-btn1.png")
                                      }
                                    }),
                                    _vm._v("本地文件")
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c("p", [_vm._v("60MB以内，pdf/doc/docx/xlsx")]),
                            _vm.progressVisible
                              ? _c("el-progress", {
                                  attrs: {
                                    "stroke-width": 10,
                                    "show-text": false,
                                    percentage: _vm.progressV
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("div", { staticClass: "content-btn" }, [
                          _c(
                            "h3",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.addBtn(2)
                                }
                              }
                            },
                            [
                              _c("el-image", {
                                staticClass: "start-icon",
                                attrs: {
                                  src: require("@/assets/img/content-btn2.svg")
                                }
                              }),
                              _vm._v("网页链接")
                            ],
                            1
                          ),
                          _c("p", [_vm._v("可以公开访问的网页")])
                        ]),
                        _c(
                          "div",
                          { staticClass: "content-btn" },
                          [
                            _c(
                              "el-upload",
                              {
                                ref: "uploadFileItem",
                                staticClass: "upload-demo",
                                attrs: {
                                  action: _vm.sendUrl,
                                  headers: _vm.headers,
                                  disabled: _vm.progressVisible2,
                                  "show-file-list": false,
                                  multiple: true,
                                  accept: _vm.fileTypeArr2.join(","),
                                  "on-progress": _vm.handleProgress2,
                                  "before-upload": _vm.beforeUploadFile2,
                                  "on-success": _vm.handleFileSuccess2,
                                  "on-error": _vm.onError2
                                }
                              },
                              [
                                _c(
                                  "h3",
                                  {
                                    class: [
                                      { "disabled-h": _vm.progressVisible2 }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.addBtn(3)
                                      }
                                    }
                                  },
                                  [
                                    _c("el-image", {
                                      staticClass: "start-icon",
                                      attrs: {
                                        src: require("@/assets/img/content-btn3.png")
                                      }
                                    }),
                                    _vm._v("标准问答对")
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c("p", [
                              _vm._v("通过模板上传xlsx格式文件，"),
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.addBtn(4)
                                    }
                                  }
                                },
                                [_vm._v("下载模板")]
                              )
                            ]),
                            _vm.progressVisible2
                              ? _c("el-progress", {
                                  attrs: {
                                    "stroke-width": 10,
                                    "show-text": false,
                                    percentage: _vm.progressV2
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-area" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingTable,
                          expression: "loadingTable"
                        }
                      ],
                      ref: "singleTable",
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        "font-size": "13px"
                      },
                      attrs: {
                        size: "medium",
                        "header-cell-style": {
                          background: "#eef1f6",
                          color: "#606266"
                        },
                        "highlight-current-row": true,
                        data: _vm.formData.docList,
                        height: "36vh"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", width: "65", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.tableParams.size *
                                        (_vm.tableParams.page - 1) +
                                        (scope.$index + 1)
                                    ) +
                                    " "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { label: "内容", "show-overflow-tooltip": true },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.webUrl || scope.row.docName
                                    ) +
                                    " "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          label: "状态",
                          width: "150",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(spo) {
                              return [
                                spo.row.status == 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "span-status",
                                        staticStyle: { color: "#00A870" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-circle-check"
                                        }),
                                        _vm._v("添加成功")
                                      ]
                                    )
                                  : spo.row.status == 1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "span-status",
                                        staticStyle: { color: "#E34D59" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-circle-close"
                                        }),
                                        _vm._v("添加失败")
                                      ]
                                    )
                                  : spo.row.status == 2
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "span-status",
                                        staticStyle: { color: "#417FF9" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-upload2"
                                        }),
                                        _vm._v("添加中")
                                      ]
                                    )
                                  : spo.row.status == -1
                                  ? _c("span", [_vm._v(" 待提交")])
                                  : _c("span", [_vm._v("--")])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operation",
                          label: "操作",
                          width: "120",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteRow(
                                          scope.row,
                                          scope.$index
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "margin-top": "10px"
                  },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.confirmWeicome()
                        }
                      }
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: { size: "small " },
                      on: { click: _vm.closeDialog }
                    },
                    [_vm._v(" 取 消")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.dialogVisibleWeb
        ? _c(
            "el-dialog",
            {
              staticClass: "add-label-dialog",
              attrs: {
                visible: _vm.dialogVisibleWeb,
                title: "添加网页数据",
                "modal-append-to-body": false,
                width: "700px",
                height: "60vh",
                "close-on-click-modal": false
              },
              on: {
                close: _vm.closeDialogWeb,
                "update:visible": function($event) {
                  _vm.dialogVisibleWeb = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "web-container" },
                [
                  _c(
                    "div",
                    { staticClass: "title-row-w" },
                    [
                      _c("el-image", {
                        staticClass: "img-left",
                        attrs: { src: require("@/assets/img/content-btn2.svg") }
                      }),
                      _c("div", { staticClass: "right" }, [
                        _c("p", [
                          _c("span"),
                          _vm._v(
                            "网页知识暂不支持自动更新，如需更新知识请重新上传"
                          )
                        ]),
                        _c("p", [
                          _c("span"),
                          _vm._v(
                            "承诺填写的网址合法，公开且已获合法授权，使用网站网址不会违反法律规定及侵犯他人合法权益"
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      ref: "formRefWeb",
                      staticClass: "demo-ruleForm",
                      staticStyle: { overflow: "auto", "max-height": "35vh" },
                      attrs: {
                        model: _vm.formDataWeb,
                        rules: _vm.rulesWeb,
                        "label-width": "0px"
                      }
                    },
                    _vm._l(_vm.formDataWeb.urls, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "form-row" },
                        [
                          _c("div", { staticClass: "index-row" }, [
                            _c("span", [_vm._v(_vm._s(index + 1))])
                          ]),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { flex: "1", margin: "0" },
                              attrs: {
                                label: "",
                                prop: "urls." + index + ".url",
                                rules: [
                                  {
                                    validator: _vm.checkUrl,
                                    required: true,
                                    trigger: "blur",
                                    currentIndex: index
                                  }
                                ]
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  size: "small",
                                  placeholder:
                                    "请输入或黏贴以https://或 http://开头的链接"
                                },
                                model: {
                                  value: item.url,
                                  callback: function($$v) {
                                    _vm.$set(item, "url", $$v)
                                  },
                                  expression: "item.url"
                                }
                              })
                            ],
                            1
                          ),
                          !(
                            _vm.formDataWeb.urls &&
                            _vm.formDataWeb.urls.length == 1
                          )
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                on: {
                                  click: function($event) {
                                    return _vm.delWeb(index)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _c("div", { staticClass: "btn-row" }, [
                _c(
                  "div",
                  {
                    class: [
                      "btn-content",
                      {
                        "disabled-btn":
                          _vm.formDataWeb.urls &&
                          _vm.formDataWeb.urls.length >= 200
                      }
                    ],
                    on: { click: _vm.addWeb }
                  },
                  [_c("span", [_vm._v("+")]), _vm._v(" 添加链接 ")]
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "margin-top": "10px"
                  },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.confirmWeicomeWeb()
                        }
                      }
                    },
                    [_vm._v("确定")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: { size: "small " },
                      on: { click: _vm.closeDialogWeb }
                    },
                    [_vm._v("取 消")]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }